<div class="modal-body">
  <form [formGroup]="formMedicion" (ngSubmit)="confirmar()">
      <div class="mb-3 row">
        <label class="col-sm-6 col-form-label text-end">Cisterna:</label>
        <div class="col-sm-6">
          <input type="text" class="form-control text-center" appOnlyNumber formControlName="codigo">
        </div>
      </div>

      <div class="mb-3 row">
        <label class="col-sm-6 col-form-label text-end">Cantidad despachada:</label>
        <div class="col-sm-6">
          <input appNumericFormatter [decimals]="0"  type="text" class="form-control text-center" formControlName="volumen">
        </div>
      </div>

      <div class="mb-3 row">
        <label class="col-sm-6 col-form-label text-end">Cantidad a 15°:</label>
        <div class="col-sm-6">
          <input appNumericFormatter [decimals]="0" type="text" class="form-control text-center" formControlName="volumen15">
        </div>
      </div>

      <div class="text-center">
        <button type="submit" class="btn btn-success px-4" [disabled]="formMedicion.invalid">
          Confirmar
        </button>
      </div>
  </form>
</div>
